<template>
  <div class="login-card__password-phone-code-card">
    <div class="login-card__title-box">
      <h5 class="login-card__title">{{ trans.get('auth.card.password_reset.phone.code.header') }}</h5>
      <p class="login-card__title-desc">{{ trans.get('auth.card.password_reset.phone.code.subheader') }}</p>
    </div>
    <div>
      <validation-observer ref="form" v-slot="{ handleSubmit }">
        <div class="row">
          <div class="col-12">
            <validation-provider name="phone" v-slot="{ errors }" mode="eager">
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="form-group">
            <validation-provider name="phone verification code" rules="required" v-slot="{ errors }" mode="eager">
              <label for="phone-verification-code"></label>
              <input
                type="text"
                id="phone-verification-code"
                class="input-code"
                v-model="form.token"
                v-input-mask data-inputmask-mask="* * * * * *"
                data-inputmask-placeholder="_ _ _ _ _ _"
                data-inputmask-clearMaskOnLostFocus="false"
                @paste="onPaste"
              >
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <button type="button" class="button button__outline px-3" @click="swapComponent('auth-reset-password-card')">{{ trans.get('auth.card.buttons.resend_pin_code') }}</button>
          <button type="submit" class="button button__icon button__icon--gradient"><i data-v-4ac6a987="" class="demo-icon icon-next"></i></button>
        </form>
      </validation-observer>

      <button type="button" class="button button__link mt-3" @click="swapComponent('auth-reset-password-card')">{{ trans.get('auth.card.buttons.back') }}</button>
    </div>
  </div>
</template>
<script>
export default {
  props: ['swapComponent', 'form'],
  methods: {
    onSubmit() {
      const self = this;
      axios.post(zRoute('password.update.phone.check'), { phone: this.form.phone, token: this.trimCode(this.form.token) }).then(function (response) {
        self.swapComponent('auth-reset-password-phone-card');
      }, function (error) {
        if (error.response.status === 422) {
          self.$refs.form.setErrors(error.response.data.errors);
        }
      });
    },
    async refreshCSRFToken() {
      axios.get(zRoute('ajax.csrf_token'))
        .then(response => {
          const token = response.data.csrfToken;
          document.querySelector('meta[name=csrf-token]').setAttribute('content', token);
          window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        });
    },
    trimCode: function (code) {
      return code.replace(/\s+/g, '');
    },
    onPaste: function (event) {
      this.form.token = event.clipboardData.getData('text');
    },
  },
  activated() {
    this.refreshCSRFToken();
  }
};
</script>
<style scoped>
</style>
